module.exports = __webpack_public_path__ + "media/tags/recycle-92489bc8.png";